/**
 * Shared dashed outline for unmanaged accounts (TMMAPP-0026). Spec says `tokens.border`;
 * this theme's control-boundary token is `lineStrong` (audited at 3:1 on surface).
 */
import type { SxProps, Theme } from '@mui/material';
import type { AppTokens } from '@/theme/tokens';

export const SHOW_UNMANAGED_KEY = 'tmm_show_unmanaged';

export function readShowUnmanaged(): boolean {
  try {
    return localStorage.getItem(SHOW_UNMANAGED_KEY) === '1';
  } catch {
    return false;
  }
}

export function writeShowUnmanaged(value: boolean): void {
  try {
    localStorage.setItem(SHOW_UNMANAGED_KEY, value ? '1' : '0');
  } catch {
    // ignore quota / private mode
  }
}

export function unmanagedOutlineSx(tokens: AppTokens): SxProps<Theme> {
  return {
    outline: `1px dashed ${tokens.lineStrong}`,
    outlineOffset: '-1px',
    // A selected menu item (the chosen account in a listbox) paints the `selected` layer, where
    // `lineStrong` is not guaranteed; `text` is (TMMAPP-0049).
    '&.Mui-selected': { outlineColor: tokens.text },
  };
}

/**
 * The unmanaged account's summary card: its own border turns dashed, so the dash never draws over
 * a solid card edge (TMMAPP-0097 B1).
 */
export function unmanagedCardBorderSx(tokens: AppTokens): SxProps<Theme> {
  return { border: `1px dashed ${tokens.lineStrong}` };
}

export function unmanagedCellOutlineSx(tokens: AppTokens): SxProps<Theme> {
  return {
    outline: `1px dashed ${tokens.lineStrong}`,
    outlineOffset: '-1px',
  };
}
